var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.806458,
    width: 38,
    height: 38,
    rx: 12,
    fill: "#E6ECF1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1541_111374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 15,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7987 13.5164C25.6119 13.3292 25.3583 13.224 25.0938 13.224C24.8292 13.224 24.5756 13.3292 24.3888 13.5164L19.4988 18.3964L14.6087 13.5064C14.4219 13.3192 14.1683 13.214 13.9038 13.214C13.6392 13.214 13.3856 13.3192 13.1987 13.5064C12.8088 13.8964 12.8088 14.5264 13.1987 14.9164L18.0887 19.8064L13.1987 24.6964C12.8088 25.0864 12.8088 25.7164 13.1987 26.1064C13.5888 26.4964 14.2188 26.4964 14.6087 26.1064L19.4988 21.2164L24.3888 26.1064C24.7788 26.4964 25.4087 26.4964 25.7987 26.1064C26.1888 25.7164 26.1888 25.0864 25.7987 24.6964L20.9087 19.8064L25.7987 14.9164C26.1788 14.5364 26.1788 13.8964 25.7987 13.5164Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1541_111374)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.80646,
    width: 24,
    height: 24,
    fill: "#383E49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_icon.fa6033fc7e2d36b06041f533831b7a1b.svg";
export { ForwardRef as ReactComponent };